/* ============================================
   PROTOBUF SCHEMA - Schema complet AiScore
   ============================================
   Extrait du widget AiScore. Utilise protobufjs
   pour décoder les messages PushMsg, MLive, Stats,
   FootballVariableDetail, etc.
   ============================================ */

import protobuf from 'protobufjs'

export const PUSHMSG_CODES = {
  MLIVE: 10101,
  STATS: 10102,
  ODDS: 10103,
  VARIABLE_DETAIL: 10105,
  TREND: 10106,
  TIMELINE: 10107,
};

const SCHEMA = {
  nested: {
    tracker: {
      nested: {
        PushMsg: {
          fields: {
            code: { type: "int32", id: 1 },
            data: { type: "bytes", id: 2 },
          },
        },
        ApiResult: {
          fields: {
            code: { type: "int32", id: 1 },
            data: { type: "bytes", id: 2 },
          },
        },
        MLiveItem: {
          fields: {
            ss: { type: "string", id: 1 },
            vc: { type: "VC", id: 2 },
            tm: { rule: "repeated", type: "int32", id: 3 },
            ot: { type: "int32", id: 4 },
            ta: { type: "int32", id: 5 },
            st: { type: "int32", id: 6 },
            data: { type: "bytes", id: 7 },
          },
        },
        MLive: {
          fields: {
            sportId: { type: "int32", id: 1 },
            matchId: { type: "int32", id: 2 },
            items: { rule: "repeated", type: "MLiveItem", id: 3 },
          },
        },
        VC: {
          fields: {
            val: { type: "string", id: 1 },
          },
        },
      },
    },

    Timer: {
      fields: {
        ticking: { type: "int32", id: 1 },
        countdown: { type: "int32", id: 2 },
        uptime: { type: "int32", id: 3 },
        second: { type: "int32", id: 4 },
        addTime: { type: "int32", id: 5 },
      },
    },
    Odds: {
      fields: {
        odd_1: { type: "string", id: 1 },
        odd_2: { type: "string", id: 2 },
        odd_3: { type: "string", id: 3 },
      },
    },
    Team: {
      fields: {
        id: { type: "int32", id: 1 },
        name: { type: "string", id: 2 },
        shortName: { type: "string", id: 3 },
        logo: { type: "string", id: 4 },
        countryName: { type: "string", id: 5 },
        countryLogo: { type: "string", id: 6 },
        shortNameEn: { type: "string", id: 7 },
      },
    },
    Tournament: {
      fields: {
        id: { type: "int32", id: 1 },
        name: { type: "string", id: 2 },
        shortName: { type: "string", id: 3 },
        logo: { type: "string", id: 4 },
        countryName: { type: "string", id: 5 },
        countryLogo: { type: "string", id: 6 },
      },
    },
    Stats: {
      fields: {
        items: { rule: "repeated", type: "StatItem", id: 1 },
      },
      nested: {
        StatItem: {
          fields: {
            code: { type: "int32", id: 1 },
            home: { type: "int32", id: 2 },
            away: { type: "int32", id: 3 },
            homeCoords: { rule: "repeated", type: "string", id: 4 },
            awayCoords: { rule: "repeated", type: "string", id: 5 },
          },
        },
      },
    },
    Environment: {
      fields: {
        weather: { type: "string", id: 1 },
        pressure: { type: "string", id: 2 },
        temperature: { type: "string", id: 3 },
        wind: { type: "string", id: 4 },
        humidity: { type: "string", id: 5 },
        weatherId: { type: "int32", id: 6 },
      },
    },
    Score: {
      fields: {
        score: { type: "int32", id: 1 },
        halfScore: { type: "int32", id: 2 },
        redCard: { type: "int32", id: 3 },
        yellowCard: { type: "int32", id: 4 },
        corner: { type: "int32", id: 5 },
        overTime: { type: "int32", id: 6 },
        penalty: { type: "int32", id: 7 },
      },
    },
    Incident: {
      fields: {
        id: { type: "int32", id: 1 },
        type: { type: "int32", id: 2 },
        second: { type: "int32", id: 3 },
        addTime: { type: "int32", id: 4 },
        belong: { type: "int32", id: 5 },
        teamId: { type: "int32", id: 6 },
        playerId: { type: "int32", id: 7 },
      },
    },
    Incidents: {
      fields: {
        items: { rule: "repeated", type: "Incident", id: 1 },
      },
    },
    LineUp: {
      fields: {
        home: { rule: "repeated", type: "Player", id: 1 },
        away: { rule: "repeated", type: "Player", id: 2 },
      },
      nested: {
        Player: {
          fields: {
            playerId: { type: "int32", id: 1 },
            status: { type: "int32", id: 2 },
            shirtNumber: { type: "int32", id: 3 },
            position: { type: "string", id: 4 },
            captain: { type: "int32", id: 5 },
            x: { type: "int32", id: 6 },
            y: { type: "int32", id: 7 },
            logo: { type: "string", id: 8 },
            rating: { type: "int32", id: 9 },
            name: { type: "string", id: 10 },
            shortName: { type: "string", id: 11 },
          },
        },
      },
    },
    Venue: {
      fields: {
        name: { type: "string", id: 1 },
        city: { type: "string", id: 2 },
        country: { type: "string", id: 3 },
        capacity: { type: "int32", id: 4 },
      },
    },
    Coach: {
      fields: {
        id: { type: "int32", id: 1 },
        name: { type: "string", id: 2 },
        logo: { type: "string", id: 3 },
      },
    },
    FootballStaticDetail: {
      fields: {
        id: { type: "int32", id: 1 },
        matchTime: { type: "int32", id: 2 },
        tournament: { type: "Tournament", id: 3 },
        homeTeam: { type: "Team", id: 4 },
        awayTeam: { type: "Team", id: 5 },
        lineup: { type: "LineUp", id: 6 },
        environment: { type: "Environment", id: 7 },
        referee: { type: "string", id: 8 },
        venue: { type: "Venue", id: 9 },
        hasProgress: { type: "int32", id: 10 },
        hasStanding: { type: "int32", id: 11 },
        seasonId: { type: "int32", id: 13 },
        stageId: { type: "int32", id: 14 },
        homeRank: { type: "string", id: 15 },
        awayRank: { type: "string", id: 16 },
        homeResult: { type: "string", id: 17 },
        awayResult: { type: "string", id: 18 },
        homeJersey: { type: "string", id: 19 },
        awayJersey: { type: "string", id: 20 },
        homeCoach: { type: "Coach", id: 21 },
        awayCoach: { type: "Coach", id: 22 },
        subscribeId: { type: "string", id: 23 },
      },
    },
    FootballVariableDetail: {
      fields: {
        id: { type: "int32", id: 1 },
        statusId: { type: "int32", id: 2 },
        homeScores: { type: "Score", id: 3 },
        awayScores: { type: "Score", id: 4 },
        timer: { type: "Timer", id: 5 },
        odds: { type: "Odds", id: 6 },
        stats: { type: "Stats", id: 7 },
        mLiveItem: { type: "tracker.MLiveItem", id: 8 },
      },
    },
    Trend: {
      fields: {
        count: { type: "int32", id: 1 },
        per: { type: "int32", id: 2 },
        data: { rule: "repeated", type: "TrendData", id: 3 },
      },
      nested: {
        TrendData: {
          fields: {
            items: { rule: "repeated", type: "int32", id: 1 },
          },
        },
      },
    },
    Timeline: {
      fields: {
        count: { type: "int32", id: 1 },
        per: { type: "int32", id: 2 },
        items: { rule: "repeated", type: "TimelineItem", id: 3 },
      },
      nested: {
        TimelineItem: {
          fields: {
            val_1: { type: "float", id: 1 },
            val_2: { type: "int32", id: 2 },
            val_3: { type: "int32", id: 3 },
          },
        },
      },
    },
    Progress: {
      fields: {
        trend: { type: "Trend", id: 1 },
        timeline: { type: "Timeline", id: 2 },
      },
    },
  },
};

let root = null;
let types = null;

function ensureInitialized() {
  if (root) return;
  root = protobuf.Root.fromJSON(SCHEMA);
  types = {
    PushMsg: root.lookupType("tracker.PushMsg"),
    ApiResult: root.lookupType("tracker.ApiResult"),
    MLive: root.lookupType("tracker.MLive"),
    MLiveItem: root.lookupType("tracker.MLiveItem"),
    Stats: root.lookupType("Stats"),
    Odds: root.lookupType("Odds"),
    FootballStaticDetail: root.lookupType("FootballStaticDetail"),
    FootballVariableDetail: root.lookupType("FootballVariableDetail"),
    Trend: root.lookupType("Trend"),
    Timeline: root.lookupType("Timeline"),
    Incident: root.lookupType("Incident"),
    LineUp: root.lookupType("LineUp"),
    Score: root.lookupType("Score"),
    Team: root.lookupType("Team"),
  };
}

/**
 * Décoder les data bytes selon le code PushMsg
 * @param {number} code - Le code PushMsg (10101, 10102, etc.)
 * @param {Uint8Array} dataBytes - Les bytes du champ data du PushMsg
 * @returns {{ type: string, decoded: Object }|null}
 */
export function decodeByCode(code, dataBytes) {
  ensureInitialized();
  if (!types || !dataBytes) return null;

  const uint8 = dataBytes instanceof Uint8Array ? dataBytes : new Uint8Array(dataBytes);

  try {
    switch (code) {
      case PUSHMSG_CODES.MLIVE:
        return {
          type: "MLive",
          decoded: types.MLive.toObject(types.MLive.decode(uint8), {
            defaults: true,
            bytes: Uint8Array,
          }),
        };
      case PUSHMSG_CODES.STATS:
        return {
          type: "Stats",
          decoded: types.Stats.toObject(types.Stats.decode(uint8), {
            defaults: true,
          }),
        };
      case PUSHMSG_CODES.ODDS:
        return {
          type: "Odds",
          decoded: types.Odds.toObject(types.Odds.decode(uint8), {
            defaults: true,
          }),
        };
      case PUSHMSG_CODES.VARIABLE_DETAIL:
        return {
          type: "FootballVariableDetail",
          decoded: types.FootballVariableDetail.toObject(
            types.FootballVariableDetail.decode(uint8),
            { defaults: true, bytes: Uint8Array }
          ),
        };
      case PUSHMSG_CODES.TREND:
        return {
          type: "Trend",
          decoded: types.Trend.toObject(types.Trend.decode(uint8), {
            defaults: true,
          }),
        };
      case PUSHMSG_CODES.TIMELINE:
        return {
          type: "Timeline",
          decoded: types.Timeline.toObject(types.Timeline.decode(uint8), {
            defaults: true,
          }),
        };
      default:
        return null;
    }
  } catch (e) {
    console.warn(`[protobuf-schema] Erreur décodage code ${code}:`, e.message);
    return null;
  }
}

/**
 * Décoder un ApiResult (réponse HTTP /api/f/sd ou /api/f/vd)
 * @param {Uint8Array} buffer - Le buffer de la réponse
 * @returns {{ code: number, data: Uint8Array }}
 */
export function decodeApiResult(buffer) {
  ensureInitialized();
  if (!types) return null;

  const uint8 = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  const apiResult = types.ApiResult.toObject(types.ApiResult.decode(uint8), {
    defaults: true,
    bytes: Uint8Array,
  });
  return apiResult;
}

/**
 * Décoder un FootballStaticDetail depuis les data bytes d'un ApiResult
 * @param {Uint8Array} dataBytes - Le champ data du ApiResult
 * @returns {Object} FootballStaticDetail décodé
 */
export function decodeStaticDetail(dataBytes) {
  ensureInitialized();
  if (!types || !dataBytes) return null;

  const uint8 = dataBytes instanceof Uint8Array ? dataBytes : new Uint8Array(dataBytes);
  return types.FootballStaticDetail.toObject(
    types.FootballStaticDetail.decode(uint8),
    { defaults: true, bytes: Uint8Array }
  );
}
